import KeepAlive from 'react-activation';
import ExamList from './ExamList';

const ExamPortal = () => {
  return (
    <KeepAlive cacheKey='examListCache' name='examListCache'>
      <ExamList />
    </KeepAlive>
  );
};

export default ExamPortal;